module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-base', {
    attrs: {
      "show-place-holder": _vm.showPlaceHolder,
      "order-detail": _vm.orderDetail,
      "express-track": _vm.expressTrack,
      "show-product-contract-no": _vm.showProductContractNo
    },
    on: {
      "goToProgressInfo": _vm.handleGoToProgressInfo,
      "goToProductInfo": _vm.handleGoToProductInfo,
      "goToExpressInfo": _vm.handleGoToExpressInfo,
      "getExpressSheet": _vm.handleGetExpressSheet
    },
    scopedSlots: _vm._u([{
      key: "addressOperation",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_vm._t("addressOperation", null, null, {
          orderDetail: orderDetail
        })]
      }
    }, {
      key: "productOperations",
      fn: function(ref) {
        var item = ref.item;
        var orderDetail = ref.orderDetail;

        return [_vm._t("productOperations", null, null, {
          item: item,
          orderDetail: orderDetail
        })]
      }
    }, {
      key: "orderOperations",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_vm._t("orderOperations", null, null, {
          orderDetail: orderDetail
        }), _vm._v(" "), _c('gc-order-detail-buttons-with-actions', {
          attrs: {
            "order-detail": orderDetail
          }
        })]
      }
    }], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117e5e22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/GcOrderDetailWithActions.vue
// module id = 1541
// module chunks = 8